var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 16.857,
    x: 0.5,
    y: 0.5,
    stroke: "#80959D",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M.5 4.083h9v9.692h-9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.156,
    cy: 2.309,
    fill: "#80959D",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.307,
    height: 1,
    x: 4.347,
    y: 15.394,
    fill: "#80959D",
    rx: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.62f4ff51d052ed85b1a7268981344a8c.svg";
export { ForwardRef as ReactComponent };